import { useState, useCallback } from "react";
import { DocumentDto } from "../types";
import { MODAL_MODES } from "../constants";

export type ModalMode = (typeof MODAL_MODES)[keyof typeof MODAL_MODES];

interface UseDocumentModalReturn {
  isOpen: boolean;
  mode: ModalMode;
  selectedDocument: DocumentDto | null;
  openAddModal: () => void;
  openEditModal: (document: DocumentDto) => void;
  closeModal: () => void;
}

export function useDocumentModal(): UseDocumentModalReturn {
  const [isOpen, setIsOpen] = useState(false);
  const [mode, setMode] = useState<ModalMode>(MODAL_MODES.CREATE);
  const [selectedDocument, setSelectedDocument] = useState<DocumentDto | null>(
    null
  );

  const openAddModal = useCallback(() => {
    setMode(MODAL_MODES.CREATE);
    setSelectedDocument(null);
    setIsOpen(true);
  }, []);

  const openEditModal = useCallback((document: DocumentDto) => {
    setMode(MODAL_MODES.EDIT);
    setSelectedDocument(document);
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    setSelectedDocument(null);
  }, []);

  return {
    isOpen,
    mode,
    selectedDocument,
    openAddModal,
    openEditModal,
    closeModal
  };
}
